export const traduction = {  
  it: {
    cannotInviteYourself: "Non puoi invitare te stesso",
    iUnderstood: "HO CAPITO"
  }
};
